import { render, staticRenderFns } from "./OrganizationalStructureMenuItem.vue?vue&type=template&id=e4488178"
import script from "./OrganizationalStructureMenuItem.vue?vue&type=script&lang=js"
export * from "./OrganizationalStructureMenuItem.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalStructureMenuItem.vue?vue&type=style&index=0&id=e4488178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports